export default __webpack_public_path__ + "abe64b6905445fe7e3c97ec7267f246a.png";